import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'

import { isPossibleDeadEndSelector } from '../selectors/isPossibleDeadEndSelector'

export function useIsPossibleDeadEnd(dialogId: string) {
  //@ts-ignored
  return useSelector<RootState, boolean>(state => isPossibleDeadEndSelector(state, dialogId))
}
